// extracted by mini-css-extract-plugin
module.exports = {"empty":"_5331"};